import React, { type InputHTMLAttributes } from 'react'
import styled from 'styled-components'
import { ErrorMessage } from '../Input'
import { Text, TextVariant } from '../Text'
import { Flex } from '../Flex'
import { CheckboxProps } from './types'

const StyledCheckbox = styled.input<
  InputHTMLAttributes<HTMLInputElement> & { singleSelect?: boolean; transparent?: boolean; round?: boolean }
>`
  appearance: none;
  overflow: hidden;
  cursor: pointer;
  position: relative;
  display: inline-block;
  border-radius: ${({ round }) => (round ? '50%' : '0')};
  height: 20px;
  width: 20px;
  min-width: 20px;
  min-height: 20px;
  vertical-align: middle;
  transition: background-color 0.2s ease-in-out;
  border: 1px solid ${({ theme }) => theme.colors.gray7}!important;
  margin: 0 !important;

  &:after {
    content: '';
    position: absolute;
    border-bottom: 2px solid;
    border-left: 2px solid;
    border-color: transparent;
    top: 31%;
    left: 0;
    right: 0;
    width: 50%;
    height: 25%;
    margin: auto;
    transform: rotate(-50deg);
    transition: border-color 0.2s ease-in-out;
  }

  &:hover:not(:disabled):not(:checked) {
    border: 1px solid ${({ theme }) => theme.colors.purple} !important;
  }

  &:checked {
    background: ${({ theme }) => theme.colors.purple}!important;

    &:after {
      border-color: ${({ theme }) => theme.colors.text} !important;
    }
  }

  &:disabled {
    cursor: default;
    opacity: 0.6;
  }
`

const Checkbox: React.FC<CheckboxProps> = ({
  label,
  singleSelect,
  clickableLabel,
  transparent,
  disabledLabel,
  round,
  error,
  errorMsg,
  testId,
  style,
  ...props
}) => {
  return (
    <Flex flexDirection="column">
      <Flex alignItems="center">
        <StyledCheckbox
          style={style}
          data-testid={testId}
          type="checkbox"
          {...props}
          transparent={transparent}
          singleSelect={singleSelect}
          round={round}
        />
        {label && (
          <>
            {React.isValidElement(label) ? (
              label
            ) : (
              <Text
                variant={TextVariant.BODY_DEFAULT_MEDIUM}
                ml="8px"
                mr="24px"
                style={{ cursor: clickableLabel ? 'pointer' : 'default', opacity: disabledLabel ? 0.5 : 1 }}
              >
                {label}
              </Text>
            )}
          </>
        )}
      </Flex>
      {error && errorMsg && <ErrorMessage>{errorMsg}</ErrorMessage>}
    </Flex>
  )
}

export default Checkbox
